import { Checkbox } from "@fluentui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useInsurerReportsStore } from "store/InsurerReportsStore";

const InsurerReportEntriesFilterBar = () => {
  const { t } = useTranslation();
  const [{ includePerfectMatches }, { setInsurerReportsStoreValue }] =
    useInsurerReportsStore();

  const checkboxStyles = {
    label: { alignItems: "center" },
    checkbox: { width: 14, height: 14 },
    checkmark: { fontSize: 10, lineHeight: "12px" },
    text: { fontSize: 12, lineHeight: "14px" },
  };

  return (
    <div
      data-help="insurer-reports-perfect-matches"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "24px",
        padding: "6px 12px",
        borderTop: "1px solid rgba(128, 128, 128, 0.2)",
      }}
    >
      <Checkbox
        label={t("pct.includePerfectMatches.label")}
        checked={includePerfectMatches}
        styles={checkboxStyles}
        onChange={(ev, checked) => {
          localStorage.setItem(
            "insurerReportsIncludePerfectMatches",
            JSON.stringify(!!checked)
          );
          setInsurerReportsStoreValue("includePerfectMatches", !!checked);
        }}
      />
    </div>
  );
};

export default InsurerReportEntriesFilterBar;
